import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import {useState} from 'react';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';
import {PageOneInitialValues} from './utilities/initialValues';
import {pageOneSchema} from './utilities/validationSchema';
import {useFarm} from 'context/farmContext';
import {useNavigate} from 'react-router-dom';
import InfoFormComponent from 'components/forms/info';
import useSetInitialProvince from 'utilities/hooks/initialProvince';

const InfoForm = () => {
  const [cities, setCities] = useState<Array<ICity>>([]);
  const navigate = useNavigate();
  const {provinces} = UseGetProvince();
  const {state, city} = useSetInitialProvince(provinces);
  const {updateTitlePage, farm} = useFarm();
  return (
    <>
      <Header title=" ثبت آگهی" />
      <div className="px-3 mt-6 mb-8 pb-12">
        <Formik
          initialValues={PageOneInitialValues(farm, state, city)}
          enableReinitialize={true}
          validationSchema={pageOneSchema}
          onSubmit={values => {
            updateTitlePage(values);
            navigate('/farm/add-ad/quality');
          }}
        >
          {({values}) => {
            if (values.state) {
              const province = provinces?.find(
                x => x.id === Number(values.state),
              );
              setCities(province?.cities || []);
            }
            return (
              <Form className="h-[110vh]">
                <InfoFormComponent cities={cities} values={values} app="farm" />
              </Form>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default InfoForm;
